
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DeliveryZonesList } from "./DeliveryZonesList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DeliveryDriversList } from "./DeliveryDriversList";

export const DeliverySettings = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Paramètres de livraison</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="zones" className="space-y-4">
          <TabsList>
            <TabsTrigger value="zones">Zones de livraison</TabsTrigger>
            <TabsTrigger value="drivers">Livreurs</TabsTrigger>
          </TabsList>

          <TabsContent value="zones">
            <DeliveryZonesList />
          </TabsContent>

          <TabsContent value="drivers">
            <DeliveryDriversList />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
